import React from "react";
import { ContentBlock, ContentState, EditorState, RawDraftEntity } from "draft-js";

export const customChunkRenderer = (
    nodeName: string,
    node: HTMLElement
): RawDraftEntity<{ innerText: string; innerHTML: string; }> | undefined => {
    const allowedNodes = [
        "div",
        "table",
        "tbody",
        "tr",
        "th",
        "td",
        "thead",
        "style",
    ];

    if (allowedNodes.includes(nodeName)) {
        return {
            type: nodeName.toUpperCase(),
            mutability: "MUTABLE" as const,
            data: {
                innerText: node.innerText,
                innerHTML: node.innerHTML,
            },
        };
    }
    return undefined;
};

export const entityMapper = (entity: any): string => {
    const validTags = new Set(["DIV", "TABLE", "TBODY", "TR", "TH", "TD", "STYLE"]);

    if (validTags.has(entity.type)) {
        const tag = entity.type.toLowerCase();
        return `<${tag}>${entity.data.innerHTML}</${tag}>`;
    }
    return "";
};

export const entityMapperToComponent = (entity: any) => {
    const tagsWithDangerousHTML = new Set(["DIV", "TABLE", "TR", "TH", "TD"]);
    const lowercaseType = entity.type?.toLowerCase();

    if (tagsWithDangerousHTML.has(entity.type)) {
        const Tag = lowercaseType as keyof JSX.IntrinsicElements;
        return () => <Tag dangerouslySetInnerHTML={{ __html: entity.data.innerHTML }} />;
    }
    if (entity.type === "TBODY") {
        return <tbody dangerouslySetInnerHTML={{ __html: entity.data.innerHTML }} />;
    }
    if (entity.type === "IMAGE") {
        return () => (
            <img
                src={entity.data.src}
                alt={entity.data.alt}
                style={{ maxWidth: "100%" }}
            />
        );
    }

    if (entity.type === "STYLE") {
        return () => <style>{entity.data.innerHTML}</style>;
    }
    return "";
};

export const customBlockRenderFunc = (block: ContentBlock) => {

    if (block.getType() === "atomic") {
        const entityKey = block.getEntityAt(0);

        if (entityKey) {
            const contentState: ContentState = EditorState.createEmpty().getCurrentContent();
            const entity = contentState.getEntity(entityKey);

            return {
                component: entityMapperToComponent(entity),
                editable: false,
                props: {
                    children: () => entity.getData().innerHTML
                },
            };
        }
    }
    return undefined;
};